import React, { useState , useEffect} from 'react'
import axios from 'axios'
import useTraeDatos from '../hooks/useTraeDatos';
import fotoVacia from '../../paginas/img/fotoVacia.jpg'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCertificate } from '@fortawesome/free-solid-svg-icons' // <-- import styles to be used
import AutoCompleta from '../componentes/AutoCompleta';


const SubirEditCertifi = ({ baseUrl, urlUsuarios, data, setData, setFuncion, registroSelect, TituloBtn, funcion, urlCursos }) => {

	const [registro, setRegistro] = useState(funcion === 'editar' ? {...registroSelect, archivo: registroSelect.archivo !== '' ? JSON.parse(registroSelect.archivo) : ''} : { activo: true, imagePrev: fotoVacia, estado: 'aprobado' })

	const [usuarios, setUsuarios] = useState([])
	const [usuario, setUsuario] = useState({})
	const [cursos, setCursos] = useTraeDatos(urlCursos)
	const [cursoSelect, setCursoSelect] = useState({})

	console.log('cursos', cursos)


	const peticionTraeDatos = async () => {
		await axios.get(urlUsuarios, { params: { usuario: '1', clave: '1', unico: 'false' } })
			.then(response => {
				setUsuarios(response.data)
			}).catch(error => {
				console.log(error)
			})
	}

	const EnviarCertificadoPost = async (id_usuario, id_curso) => {

		let fecha = moment().format('DD-MM-YYYY')
		const code = Math.floor(1000000 + Math.random() * 9000000).toString().substring(0, 7);

		let f = new FormData()
		f.append('id_curso', id_curso)
		f.append('id_usuario', id_usuario)
		f.append('archivo', `/pdfs/${id_usuario}${id_curso}${code}.pdf`)
		f.append('nombre_archivo', `${id_usuario}${id_curso}${code}.pdf`)
		f.append('nombre', usuario.nombre)
		f.append('nombreCurso', cursoSelect.nombre)
		f.append('fecha', fecha)
		f.append('plantilla', urlCursos + cursoSelect.imagencert)
		f.append('METHOD', 'POST')

		await axios.post(baseUrl, f)

			.then(response => {
				console.log(response.data)
				setData([...data, {...response.data, usuario: usuario.usuario} ])
				setFuncion('ver')
			}).catch(error => {
				console.log('muestra erro: ' + error);
			})
	}

	const peticionPut = async () => {
		EnviarCertificadoPost(usuario.id, cursoSelect.id )
	}

  useEffect(() =>{
	peticionTraeDatos()
  },[])

  const handleChange = (event) => {
    const itemId = event.target.value
    const item = cursos.find((i) => i.nombre === itemId);
    setCursoSelect(item)
  };


	return (
		<div>
			<div className="row">
				<div className="col-md-12">
					<div><hr />

						<div className='row'>
							<div className='col-md-12'>

							<AutoCompleta 
								registro={usuario}
								setRegistro={setUsuario}
								productos={usuarios}
								tipo='usuario'
							/>
							
							<select className="browser-default custom-select selectEstado"
									name="curso"
									value={cursoSelect.nombre}
									onChange={handleChange}>
										<option value="">Selecciona Curso a Certificar</option>
										{cursos.map(item => {
											return(
												<option key={item.id} value={item.nombre}>{item.nombre}</option>
											)
										})}
							</select>
							
							{usuario.usuario !== undefined || registro.curso !== undefined ?
							<div className='col-md-12'>		
								<div style={{backgroundColor: '#e3e3e3', marginTop: 15, borderRadius: 10, paddingTop: 15, paddingBottom: 15}} className='row'>
									<div className='col-md-8'>
										<h4><FontAwesomeIcon icon={faCertificate} size="1x" style={{color: '#1d65f4'}}/> {usuario.nombre}</h4>
										<span>{usuario.usuario}</span><br/>
										<span><b>{cursoSelect.nombre}</b></span>
									</div>
									<div className='col-md-4'>
										<div className={`estadosFULL ${registro.estado}`}>{registro.estado}</div>
									</div>
								</div>
							</div>	
							:null}

							</div>
						</div>

						<br />
						<div className="col text-center">
							<button onClick={peticionPut} className="btn boton_estandar">Crear Certificado</button>
						</div>
					</div>
					

					<br></br><br></br>
				</div>
			</div>
		</div>
	)
}

export default SubirEditCertifi